/** Currencies whose prices are written without cents. */
const WHOLE_UNITS = new Set(['JPY', 'KRW', 'IDR', 'VND', 'CLP', 'COP', 'HUF', 'ISK', 'PKR', 'CRC', 'KZT', 'XOF']);

/** "CA$38.64", "¥5,980" or "kr 129.00" for a USD amount in a currency record. */
export function formatIn(usd, currency) {
  const code = String(currency?.Name || '').toUpperCase();
  const digits = WHOLE_UNITS.has(code) ? 0 : 2;
  const value = Number(usd || 0) * Number(currency?.rate_c || 0);
  const amount = value.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  const symbol = String(currency?.symbol_c ?? '');
  // Letter symbols (kr, Rp, Kč, AED) read better with a gap before the number.
  const gap = /\p{L}$/u.test(symbol) ? ' ' : '';
  return `${symbol}${gap}${amount}`;
}

/** "INR ₹" for the picker; just the code when the symbol is the code. */
export function currencyLabel(currency) {
  const code = String(currency?.Name || '');
  const symbol = String(currency?.symbol_c ?? '');
  return symbol && symbol !== code ? `${code} ${symbol}` : code;
}
